import { gql } from "@apollo/client";

export default gql`
  query Actor($id: Int!) {
    actor(id: $id) {
      id
      officialDocument
      officialName
      openingDate
      cnae
      nickname
      documentType
      addresses {
        id
        name
        latitude
        longitude
        country
        state
        city
        street
        number
        postalCode
        neighborhood
        complement
        reference
        formattedAddress
        routePoints {
          id
        }
      }
      partnershipAsPartner {
        id
        internalCode
        contactDetails
        description
        nickname
        roles {
          id
          role
          accessGroup {
            id
            name
            slug
          }
        }
      }
    }
  }
`;
